// Vendor Libs
import {isBoolean} from 'lodash';

const initialState = {
    autoClose: false,
    error: null,
    success: null,
};

const actions = {
    GLOBAL_RESPONSE_ADD: (_state, {autoClose, error, success}) => {
        const newAutoClose = isBoolean(autoClose) ? autoClose : !!success;

        return {autoClose: newAutoClose, error, success};
    },

    GLOBAL_RESPONSE_RESET: () => initialState,
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
